export default {
    PLATFORMS: {
        TERM_FINANCE: 'TF',
        AXCEL_FINANCE: 'AF',
        STANDARD_CREDIT: 'SC',
    },

    LOAN_TYPES: {
        PERSONAL: 1,
        BUSINESS: 2,
        CAR: 3,
    },

    CAR_LOAN_TYPES: {
        COLLATERAL: 10,
        PURCHASE: 20,
    },

    PERSONAL_INSURANCE_TYPES: {
        BASIC: {
            id: 'BASIC',
            label: 'TF Essential',
            percentage: {
                TT: 0.0055,
                BB: 0.0055,
                JM: 0.0055,
                GY: 0.0055,
                LC: 0.0055,
                VC: 0.0055,
                AG: 0.0055,
                GD: 0.0055,
            },
        },
        PRO: {
            id: 'PRO',
            label: 'TF Upgraded',
            percentage: {
                TT: 0.007,
                BB: 0.007,
                JM: 0.007,
                GY: 0.007,
                LC: 0.007,
                VC: 0.007,
                AG: 0.007,
                GD: 0.007,
            },
        },
    },

    STORES: {
        TEST: 1,
        '1_GY': 404,
        '1_TT': 2,
        '1_BB': 403,
        '1_JM': 405,
        '1_LC': 406,
        '1_AG': 932,
        '1_GD': 1162,
        '1_DM': 2201,
        '2_TT': 437,
        '2_BB': 586,
    },

    COUNTRIES: {
        TT: {
            key: 'TT',
            name: 'Trindad & Tobago',
            locale: 'tt',
            currency: 'TTD',
            areaCode: '868',
        },
        BB: {
            key: 'BB',
            name: 'Barbados',
            locale: 'bb',
            currency: 'BBD',
            areaCode: '246',
        },
        DM: {
            key: 'DM',
            name: 'Dominica',
            locale: 'dm',
            currency: 'XCD',
            areaCode: '767',
        },
        JM: {
            key: 'JM',
            name: 'Jamaica',
            locale: 'jm',
            currency: 'JMD',
            areaCode: '876',
        },
        GY: {
            key: 'GY',
            name: 'Guyana',
            locale: 'gy',
            currency: 'GYD',
            areaCode: '592',
        },
        LC: {
            key: 'LC',
            name: 'St. Lucia',
            locale: 'lc',
            currency: 'XCD',
            areaCode: '758',
        },
        VC: {
            key: 'VC',
            name: 'St. Vincent',
            locale: 'vc',
            currency: 'XCD',
            areaCode: '1',
        },
        AG: {
            key: 'AG',
            name: 'Antigua',
            locale: 'ag',
            currency: 'XCD',
            areaCode: '1',
        },
        GD: {
            key: 'GD',
            name: 'Grenada',
            locale: 'gd',
            currency: 'XCD',
            areaCode: '473',
        },
    },

    LOCATIONS: {
        SJ: {
            label: 'St. James',
            value: 'SJ',
        },
        GB: {
            label: 'Grand Bazaar',
            value: 'GB',
        },
        SL: {
            label: 'Starlite Shopping Plaza',
            value: 'SL',
        },
        AM: {
            label: 'Aboutique Mall',
            value: 'AM',
        },
        MH: {
            label: 'Mt. Hope',
            value: 'MH',
        },
        CS: {
            label: 'Coffee Street',
            value: 'CS',
        },
        Online: {
            label: 'Online',
            value: 'ONLINE',
        },
    },
};
